import {createStore} from 'redux';
import Immutable from 'immutable';
import {reduce} from './reducer';


const initialState = Immutable.Map({});

function reducerWrapper(state = initialState, action) {
	let res = reduce(state, action);
	//console.log('action', action);
	//console.log(res.toJS());
	return res;
}

let store = createStore(reducerWrapper);

export default store;

import './module';
import './modal';
import './globalcontext';

